import LoadingSidebar from "~/components/search/loading/LoadingSidebar";

export default function Sidebar({ isLoading = false, top = 0, paddings = 10, children }) {
    
    const styles = {
        top: top + paddings + 'px',
        maxHeight: `calc(100vh - ${top + paddings * 2}px)`
    }
    
    return (
        <div className="el-sidebar" style={styles}>
            {isLoading && <LoadingSidebar />}
            {!isLoading && children}
        </div>
    )
}